import { useGate, useStore } from 'effector-react'
import { PreparedCard, RoutingPanelFeatureProps } from 'features/routing-panel/types'
import React, { FC, useEffect, useMemo } from 'react'
import styled, { useTheme } from 'styled-components'
import { Tab, Tabs } from 'ui/tabs'

import { GetCarsCountResponse } from '../../../api/cars'
import { useAVNConfig } from '../../../stages/AVN'
import { createImages } from '../../car/normalization/image'
import { $routingPanelData, $routingPanelGate } from '../model'
import { createId } from '../model/utils'
import { PanelSlider } from './PanelSlider'

export const RoutingPanel: FC<RoutingPanelFeatureProps> = (props) => {
  useGate($routingPanelGate, props)

  useEffect(() => {
    return () => {}
  })

  const theme = useTheme()
  let AVNConfig = useAVNConfig()

  const routingPanelData = useStore($routingPanelData)
  let tabsData = props.tabs

  const preparedCards: PreparedCard[] = useMemo(() => {
    if (AVNConfig.routingPanel?.useBackendFilter) {
      tabsData = routingPanelData?.tabs
      return (
        routingPanelData?.cards?.map((card) => {
          return {
            group: card.group,
            quantity: card.quantity,
            name: card.name,
            price: card.price,
            filter: card.filter,
            id: createId(card),
            imageId: card.imageId,
            image: createImages(
              [card.imageId],
              card.placeholders || {},
              props.imagesSettings,
              props.imagesSettings.adaptive,
              theme
            )[0]
          }
        }) || []
      )
    } else {
      return props.cards.map((card) => {
        return {
          group: card.group,
          quantity: card.quantity,
          name: card.name,
          price: card.price,
          filter: card.filter,
          id: createId(card),
          imageId: card.imageId,
          image: createImages(
            [card.imageId],
            card.placeholders || {},
            props.imagesSettings,
            props.imagesSettings.adaptive,
            theme
          )[0]
        }
      })
    }
  }, [props?.cards, props.imagesSettings, theme, routingPanelData])
  console.log({ tabsData })
  return (
    <Wrapper>
      {tabsData?.length ? (
        <Tabs positionImageInTabs={props.positionImageInTabs} cdnUrl={AVNConfig.routingPanel?.imagesSettings.cdnUrl}>
          {tabsData.map((tab, index) => {
            const cardsForCurrentTab = preparedCards.filter((card) => {
              return !tab.group || tab.group === card.group
            })
            return (
              <Tab title={tab.tab} key={index} image={tab.icon_image_id}>
                <PanelSlider
                  cards={cardsForCurrentTab}
                  sliderConfig={props.sliderConfig}
                  showCarsCount={props.showCarsCount}
                  imagesSettings={props.imagesSettings}
                />
              </Tab>
            )
          })}
        </Tabs>
      ) : (
        <PanelSlider
          cards={preparedCards}
          sliderConfig={props.sliderConfig}
          showCarsCount={props.showCarsCount}
          imagesSettings={props.imagesSettings}
        />
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div``
